import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SearchIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.4615 8.11515C10.4615 9.81448 9.08395 11.1921 7.38461 11.1921C5.68527 11.1921 4.30769 9.81448 4.30769 8.11515C4.30769 6.41581 5.68527 5.03822 7.38461 5.03822C9.08395 5.03822 10.4615 6.41581 10.4615 8.11515ZM10.1517 12.1876C9.36308 12.7244 8.41049 13.0382 7.38461 13.0382C4.66567 13.0382 2.46153 10.8341 2.46153 8.11515C2.46153 5.39621 4.66567 3.19207 7.38461 3.19207C10.1036 3.19207 12.3077 5.39621 12.3077 8.11515C12.3077 9.14103 11.9938 10.0936 11.4571 10.8822L14.4988 13.924C14.8593 14.2845 14.8593 14.8689 14.4988 15.2294C14.1383 15.5899 13.554 15.5899 13.1935 15.2294L10.1517 12.1876Z"
		/>
	</svg>
))
